import { layoutMarkup } from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {sortingActivityDefaultContent} from './sortingActivitySectionDefaultContent';
import {componentsHelper} from "../../helpers/componentsHelper";
import l10n from "../../../lang/locallang";

export const sortingActivitySection = (param, is_public = false) => {
    componentsHelper.updateLocalization(sortingActivityDefaultContent);
    const { sortingActivityTexts } = l10n;
    param.class = param.class ? param.class : 'editor-section editor-sorting-activity';
    param.style = param.style ? param.style : '';
    param.layout = param.layout ? param.layout : '';
    param.section = 'sortingActivitySection';
    let defaultList = {
        'cards': {
            1: {
                'id': '1',
                'title': sortingActivityTexts[1].cardTitle,
                'section_id': '1',
            },
            2: {
                'id': '2',
                'title': sortingActivityTexts[2].cardTitle,
                'section_id': '2',
            }
        },
        'sections': {
            1: {
                'id': '1',
                'title': sortingActivityTexts[1].sectionTitle,
            },
            2: {
                'id': '2',
                'title': sortingActivityTexts[2].sectionTitle,
            }
        }
    };
    let add_category_button = `<div class="add-new-category"><i class="icon icon-plus"></i></div>`;
    let list = param.content && param.content.list ? param.content.list : defaultList;

    const { enterCardText, addCard, replay } = l10n.editor;
    let cardsHTML = '';
    let categoriesHTML = '';
    // shuffle cards for public view
    if (is_public) {
        list.cards = componentsHelper.shuffleObject(list.cards);
    }
    for (let key in list.cards) {
        let card = list.cards[key];
        cardsHTML += `
        <div class="sorting-activity-item" data-id="${card.id}" data-category="${card.section_id}">
            ${!is_public ? `
                <div class="sorting-activity-item-actions">
                    <button class="sorting-activity-item-add"><i class="icon icon-plus"></i></button>
                    <button class="sorting-activity-item-delete"><i class="icon icon-trash"></i></button>
                </div>
            ` : ''}
          <span ${!is_public ? `contenteditable="true" class="editable-text" placeholder="${enterCardText}"` : ''}>${card.title}</span>
          <div class="item-handle"></div>
        </div>`;
    }
    let categoriesIDX = 0;
    for (let key in list.sections) {
        let category = list.sections[key];
        categoriesHTML += `
        <div class="sorting-activity-area" data-id="${category.id}">
            ${!is_public ? `
                <div class="btn-set">
                   <button class="sorting-activity-item-add hint-bottom" data-hint="${addCard}"><i class="icon flicon-ic_fluent_note_add_20_regular"></i></button>
                   <button class="sorting-activity-area-delete"><i class="icon icon-trash"></i></button>
                </div>
            ` : ''}
                <span ${!is_public ? `contenteditable="true" class="editable-text" placeholder="${enterCardText}"` : ''}>${category.title}</span>
            </div>`;
        categoriesIDX++;

    }
    add_category_button = categoriesIDX < 4 && !is_public ? `<div class="add-new-category"><i class="icon icon-plus"></i></div>` : ``;

    param.component = `
    <div class="sorting-activity">
      <div class="sorting-activity-stack">

        ${cardsHTML}

        <div class="sorting-activity-result">
          <div class="sorting-activity-result-text"></div>
          <button class="sorting-activity-reset-btn">
            <span>${replay}</span>
            <i class="icon-reset"></i>
          </button>
        </div>
      </div>
      <div class="sorting-activity-areas-wrap">
          <div class="sorting-activity-areas">
            ${categoriesHTML}
          </div>
          ${add_category_button}
      </div>
    </div>`;

    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
};
